import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { Tag } from 'primereact/tag'
import { Image } from 'primereact/image';
import EditIcon from '../../../assets/images/icons/edit.svg';
import DuplicateIcon from '../../../assets/images/icons/duplicate.svg';
import ArchiveIcon from '../../../assets/images/icons/archive.svg';
import ReportIcon from '../../../assets/images/icons/report.svg';
import SampleIcon from '../../../assets/images/icons/sample.svg';
import DatePicker from '../../date/DatePicker';
import Toolbar from '@mui/material/Toolbar';
import MenuIcon from '@mui/icons-material/Menu';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import BootstrapDateRangePicker from '../../date/BootstrapDateRangePicker';
import { Dropdown } from 'primereact/dropdown';

export default function Dooh() {
   const [date, setDate] = useState(null);
   const [supplyData, setSupplyData] = useState([]);
   const [selectedProducts, setSelectedProducts] = useState(null);
   const [rowClick, setRowClick] = useState(false);
   const [globalFilterValue, setGlobalFilterValue] = useState('');
   const [filters, setFilters] = useState({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      'name': { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      representative: { value: null, matchMode: FilterMatchMode.IN },
      status: { value: null, matchMode: FilterMatchMode.EQUALS },
      verified: { value: null, matchMode: FilterMatchMode.EQUALS }
   });

   // const paginatorLeft = <Button type="button" icon="pi pi-refresh" text />;
   // const paginatorRight = <Button type="button" icon="pi pi-download" text />;

   const paginatorTemplate = {
      layout: 'RowsPerPageDropdown CurrentPageReport NextPageLink PrevPageLink',
      RowsPerPageDropdown: (options) => {
          const dropdownOptions = [
              { label: 5, value: 5 },
              { label: 10, value: 10 },
              { label: 20, value: 20 },
              { label: 120, value: 120 }
          ];

          return (
              <React.Fragment>
                  <div className='paginatorLeft'>
                      <span className="mx-1" style={{ color: 'var(--text-color)', userSelect: 'none' }}>
                          Rows per page {' '}
                      </span>
                      <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />
                  </div>
              </React.Fragment>
          );
      },
      CurrentPageReport: (options) => { 
          return (
              <div className='paginatorRight'>
                  <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
                      Pages {options.first} of {options.totalRecords}
                  </span> 
              </div>
          );
      }
  };


   const onGlobalFilterChange = (e) => {
      const value = e.target.value;
      let _filters = { ...filters };

      _filters['global'].value = value;

      setFilters(_filters);
      setGlobalFilterValue(value);
   };

   const renderHeader = () => {
      return (
         <div className="flex justify-content-end" style={{ display: 'flex', justifyContent: 'end' }}>
            <span className="p-input-icon-left">
               <i className="pi pi-search" />
               <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Search" />
            </span>
            <span className="p-input-icon-left">
               <i className="pi pi-calendar" />
               <BootstrapDateRangePicker />
            </span>
            <span className="p-input-icon-left">
               <i className="pi pi-filter" />
               <InputText placeholder="Filter" />
            </span>
         </div>
      );
   };

   const header = renderHeader();

   const [statuses] = useState(['Active', 'Stopped']);

   const getSeverity = (status) => {
      switch (status) {
         case 'Active':
            return 'sucess';
         case 'Stopped':
            return 'danger';
      }
   };
   const statusBodyTemplate = (rowData) => {
      return <Tag value={rowData.status} severity={getSeverity(rowData.status)} className={getSeverity(rowData.status) === 'sucess' ? 'status status-active' : 'status status-stopped'} />;
   };

   const actionBtn = () => {
      return (
         <div className="actionBtn flex justify-content-center">
            <Button link><Image src={EditIcon} alt="Image" width="15" /></Button>
            <Button link><Image src={DuplicateIcon} alt="Image" width="15" /></Button>
            <Button link><Image src={ArchiveIcon} alt="Image" width="15" /></Button>
            <Button link><Image src={ReportIcon} alt="Image" width="15" /></Button>
            <Button link><Image src={SampleIcon} alt="Image" width="15" /></Button>

         </div>
      );
   };

   return (
      <div className="card">
         <Toolbar>
            <Typography variant="h6" noWrap component="div">
               <h2>DOOH</h2>
            </Typography>
            <Link to='/addCampaign'><Button type="button" icon="pi pi-plus" className="button-style-1" label="Add Campaign" size="small"></Button></Link>

            <IconButton
               color="inherit"
               aria-label="open drawer"
               edge="start"
               sx={{ mr: 2, display: { sm: 'none' } }}>
               <MenuIcon />
            </IconButton>
         </Toolbar>
         <DataTable value={supplyData}
            filters={filters}
            header={header} emptyMessage="No customers found."
            selectionMode={rowClick ? null : 'checkbox'}
            selection={selectedProducts}
            onSelectionChange={(e) => setSelectedProducts(e.value)}
            dataKey="id"
            paginator rows={10} rowsPerPageOptions={[5, 10, 25, 50]}
            paginatorTemplate={paginatorTemplate}
            //paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
            //currentPageReportTemplate="{first} to {last} of {totalRecords}" 
            // paginatorLeft={paginatorLeft} paginatorRight={paginatorRight}
            tableStyle={{ minWidth: '50rem' }} resizableColumns>
            <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column>
            <Column field="Campaign Name " header="Campaign Name "></Column>
            <Column field="status" header="Status" style={{ minWidth: '12rem' }} body={statusBodyTemplate} headerStyle={{ textAlign: 'center' }} alignHeader={'center'} bodyStyle={{ textAlign: 'center' }}></Column>
            <Column field="Campaign Dates" header="Campaign Dates" headerStyle={{ textAlign: 'center' }} alignHeader={'center'} bodyStyle={{ textAlign: 'center' }}></Column>
            <Column field="Budget" header=" Budget" headerStyle={{ textAlign: 'center' }} alignHeader={'center'} bodyStyle={{ textAlign: 'center' }}></Column>
            <Column field="eCPM" header="eCPM" headerStyle={{ textAlign: 'center' }} alignHeader={'center'} bodyStyle={{ textAlign: 'center' }}></Column>
            <Column field="action" body={actionBtn} header="Action" headerStyle={{ textAlign: 'center' }} alignHeader={'center'} bodyStyle={{ textAlign: 'center' }}></Column>
         </DataTable>
      </div>


   )
}

